import { auth } from '../firebase';
import { mutateCareRecords } from '../../features/sourceLifecycle/sourceLifecycleService';

const TIMELINE_COLLECTIONS = new Set(['dailyLogs', 'dailyCare', 'incidents']);

export const softDeleteTimelineEntry = async (entry) => {
  const collection = entry?.collection || 'dailyLogs';
  if (!entry?.id || !TIMELINE_COLLECTIONS.has(collection)) {
    throw Object.assign(new Error('This entry cannot be deleted from Timeline.'), { code: 'unsupported-entry' });
  }
  if (!auth.currentUser?.uid) {
    throw Object.assign(new Error('Please sign in again before deleting this entry.'), { code: 'unauthenticated' });
  }

  return mutateCareRecords(entry.kind === 'story'
    ? { operation: 'delete_story', sourceNoteId: entry.sourceNoteId || entry.id }
    : { operation: 'delete', entry: { id: entry.id, collection }, ...(entry.sourceRevision ? { expectedRevision: entry.sourceRevision } : {}) });
};
